import { logMethodCall } from './debug';

export function appendHiddenIframe(url) {
  logMethodCall('appendHiddenIframe');

  const iframe = document.createElement('iframe');
  iframe.src = url;
  iframe.name = 'cleverpush-iframe';
  iframe.style.display = 'none';
  iframe.style.width = `${1}px`;
  iframe.style.height = `${1}px`;
  iframe.style.opacity = 0;
  iframe.style.pointerEvents = 'none';
  document.body.appendChild(iframe);

  return iframe;
}

export function popup(url, w, h, topParam, leftParam) {
  logMethodCall('popup', url, w, h);

  const dualScreenLeft = window.screenLeft !== undefined ? window.screenLeft : screen.left;
  const dualScreenTop = window.screenTop !== undefined ? window.screenTop : screen.top;
  const width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width;
  const height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height;
  let left = typeof topParam !== 'undefined' && !isNaN(topParam) ? topParam : ((width / 2) - (w / 2)) + dualScreenLeft;
  let top = typeof leftParam !== 'undefined' && !isNaN(leftParam) ? leftParam : ((height / 2) - (h / 2)) + dualScreenTop;

  let additionalParams = 'scrollbars=yes';

  const popupWindow = window.open(url, '_blank', `width=${w}, height=${h}, top=${top}, left=${left}${typeof additionalParams !== 'undefined' ? additionalParams : ''}`);

  if (popupWindow) {
    if (popupWindow.focus) {
      popupWindow.focus();
    }
  }

  return popupWindow;
}
